import { usePreQuestions } from "@/components/features/items/edit/_shared/ui/components/main/questions/pre-question/hooks";

import { useAccommodationHotelPolicyI18nFormModelContext } from "../../../../../context";

export const useReservationBasePolicyPreQuestions = () => {
	const { viewModel, onSetViewModel } = useAccommodationHotelPolicyI18nFormModelContext();
	const { questions } = viewModel;

	return usePreQuestions({ questions, onSetViewModel });
};
